import React from 'react';

function Story() {
    return (
        <div>
            <h1>Story</h1>
        </div>
    );
}

export default Story;